// Polyfills for browser compatibility
export const global = window;
export const process = {
  env: { NODE_ENV: 'production' }
};
